// lib/personalEinsatz.js — aus dem Personalkonto in Waage, Check-in oder Kampfrichter-App (18.10.2026)
//
// Das Personalkonto (Token role 'personal') trägt kein Turnier. Für Waage,
// Check-in und Kampfrichter-App holt StaffDashboard je Turnier und Rolle einen
// Einsatz-Zugang (POST /api/personal/einsatz-zugang) in der Form, die diese
// Seiten seit jeher lesen. Das Personal-Token bleibt unter 'personalToken'
// liegen, damit /staff danach wieder das eigene Konto zeigt.

const SCHLUESSEL = 'personalToken';

export function personalToken() {
  try {
    const eigen = localStorage.getItem(SCHLUESSEL);
    if (eigen) return eigen;
    const t = localStorage.getItem('token');
    const d = t ? JSON.parse(atob(t.split('.')[1])) : null;
    return d && d.role === 'personal' && !d.einsatz ? t : null;
  } catch { return null; }
}

export function personalTokenMerken(token) {
  try { localStorage.setItem(SCHLUESSEL, token); } catch { /* Speicher gesperrt */ }
}

export function personalAbmelden() {
  try {
    localStorage.removeItem(SCHLUESSEL);
    localStorage.removeItem('token');
    localStorage.removeItem('staffData');
    sessionStorage.removeItem('kr_anmeldung');
  } catch { /* egal */ }
}

/** Einsatz-Zugang holen und ablegen; liefert die Zieladresse. Wirft mit Klartext. */
export async function einsatzOeffnen(turnierId, rolle) {
  const r = await fetch('/api/personal/einsatz-zugang', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${personalToken() || ''}` },
    body: JSON.stringify({ turnier_id: turnierId, rolle }),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok || !d.success) throw new Error(d.error || `Fehler ${r.status}`);
  const { token, daten } = d;
  if (rolle === 'kampfrichter') {
    sessionStorage.setItem('kr_anmeldung', JSON.stringify({
      token,
      kampfrichter: { id: daten.id, name: daten.name, turnier_id: daten.turnier_id, matte_nummer: daten.matte_nummer || null },
    }));
    return daten.matte_nummer ? `/judge/${daten.matte_nummer}` : '/judge';
  }
  localStorage.setItem('token', token);
  return rolle === 'waage' ? '/einwaage-staff' : '/reg';
}
